import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-primary text-white">
      {/* Main Footer */}
      <div className="max-w-[1400px] mx-auto px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Company Info */}
          <div>
            <div className="flex items-center space-x-3 mb-6">
              <div className="w-10 h-10 flex items-center justify-center bg-secondary rounded-lg">
                <i className="ri-computer-line text-2xl text-white"></i>
              </div>
              <div>
                <h3 className="text-xl font-bold">Es Donanım Bilgisayar</h3>
                <p className="text-xs text-neutral-300">Teknik Servis &amp; Alım Satım</p>
              </div>
            </div>
            <p className="text-neutral-300 text-sm leading-relaxed mb-6">
              2. el bilgisayar alım satım ve profesyonel teknik servis hizmetlerinde güvenilir çözüm ortağınız. Uzman kadromuzla yanınızdayız.
            </p>
            {/* Social Media */}
            <div className="flex items-center space-x-3">
              <a
                href="https://facebook.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center bg-white/10 hover:bg-secondary rounded-lg transition-colors cursor-pointer"
              >
                <i className="ri-facebook-fill text-lg"></i>
              </a>
              <a
                href="https://twitter.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center bg-white/10 hover:bg-secondary rounded-lg transition-colors cursor-pointer"
              >
                <i className="ri-twitter-x-line text-lg"></i>
              </a>
              <a
                href="https://instagram.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center bg-white/10 hover:bg-secondary rounded-lg transition-colors cursor-pointer"
              >
                <i className="ri-instagram-line text-lg"></i>
              </a>
              <a
                href="https://linkedin.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center bg-white/10 hover:bg-secondary rounded-lg transition-colors cursor-pointer"
              >
                <i className="ri-linkedin-fill text-lg"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-bold mb-6">Hızlı Erişim</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-neutral-300 hover:text-secondary transition-colors text-sm cursor-pointer">
                  Ana Sayfa
                </Link>
              </li>
              <li>
                <Link to="/hakkimizda" className="text-neutral-300 hover:text-secondary transition-colors text-sm cursor-pointer">
                  Hakkımızda
                </Link>
              </li>
              <li>
                <Link to="/hizmetler" className="text-neutral-300 hover:text-secondary transition-colors text-sm cursor-pointer">
                  Hizmetlerimiz
                </Link>
              </li>
              <li>
                <Link to="/urunler" className="text-neutral-300 hover:text-secondary transition-colors text-sm cursor-pointer">
                  2. El Ürünler
                </Link>
              </li>
              <li>
                <Link to="/teknik-servis" className="text-neutral-300 hover:text-secondary transition-colors text-sm cursor-pointer">
                  Teknik Servis
                </Link>
              </li>
              <li>
                <Link to="/blog" className="text-neutral-300 hover:text-secondary transition-colors text-sm cursor-pointer">
                  Blog
                </Link>
              </li>
              <li>
                <Link to="/iletisim" className="text-neutral-300 hover:text-secondary transition-colors text-sm cursor-pointer">
                  İletişim
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-lg font-bold mb-6">Hizmetlerimiz</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/hizmetler/ikinci-el-bilgisayar-alim" className="text-neutral-300 hover:text-secondary transition-colors text-sm cursor-pointer">
                  2. El Bilgisayar Alım
                </Link>
              </li>
              <li>
                <Link to="/hizmetler/bilgisayar-tamiri" className="text-neutral-300 hover:text-secondary transition-colors text-sm cursor-pointer">
                  Bilgisayar Tamiri
                </Link>
              </li>
              <li>
                <Link to="/hizmetler/laptop-servisi" className="text-neutral-300 hover:text-secondary transition-colors text-sm cursor-pointer">
                  Laptop Servisi
                </Link>
              </li>
              <li>
                <Link to="/hizmetler/kurumsal-destek" className="text-neutral-300 hover:text-secondary transition-colors text-sm cursor-pointer">
                  Kurumsal Destek
                </Link>
              </li>
              <li>
                <Link to="/hizmetler/format-atma" className="text-neutral-300 hover:text-secondary transition-colors text-sm cursor-pointer">
                  Format Atma
                </Link>
              </li>
              <li>
                <Link to="/hizmetler/ekran-degisimi" className="text-neutral-300 hover:text-secondary transition-colors text-sm cursor-pointer">
                  Ekran Değişimi
                </Link>
              </li>
              <li>
                <Link to="/hizmetler/ssd-ram-yukseltme" className="text-neutral-300 hover:text-secondary transition-colors text-sm cursor-pointer">
                  SSD/RAM Yükseltme
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-bold mb-6">İletişim</h4>
            <ul className="space-y-4">
              <li className="flex items-start space-x-3">
                <i className="ri-map-pin-line text-secondary text-lg mt-1"></i>
                <span className="text-neutral-300 text-sm">
                  Anafartalar Cad. Ulus Şehir Çarşısı No:3/11<br />
                  Altındağ / ANKARA
                </span>
              </li>
              <li className="flex items-center space-x-3">
                <i className="ri-phone-line text-secondary text-lg"></i>
                <a href="tel:+905065376985" className="text-neutral-300 hover:text-secondary transition-colors text-sm cursor-pointer">
                  0506 537 69 85
                </a>
              </li>
              <li className="flex items-center space-x-3">
                <i className="ri-mail-line text-secondary text-lg"></i>
                <a href="mailto:info@esbilgisayar.com.tr" className="text-neutral-300 hover:text-secondary transition-colors text-sm cursor-pointer">
                  info@esbilgisayar.com.tr
                </a>
              </li>
              <li className="flex items-center space-x-3">
                <i className="ri-time-line text-secondary text-lg"></i>
                <span className="text-neutral-300 text-sm">
                  Pzt-Cmt: 09:00 - 19:00<br />
                  Pazar: Kapalı
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-white/10">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-8 py-6">
          <div className="flex flex-col md:flex-row items-center justify-between space-y-4 md:space-y-0">
            <p className="text-neutral-300 text-sm text-center md:text-left">
              © 2024 Es Donanım Bilgisayar. Tüm hakları saklıdır.
            </p>
            <div className="flex items-center space-x-6">
              <Link to="/gizlilik-politikasi" className="text-neutral-300 hover:text-secondary transition-colors text-sm cursor-pointer">
                Gizlilik Politikası
              </Link>
              <Link to="/kullanim-kosullari" className="text-neutral-300 hover:text-secondary transition-colors text-sm cursor-pointer">
                Kullanım Koşulları
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;